import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { formatCurrency } from '../../utils/formatters';

// Reusable components
const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <ReceiptIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL')}</TableCell>
    <TableCell align="right">{formatCurrency(valueUSD, 'USD')}</TableCell>
  </TableRow>
);

/**
 * AdvisoryInvoiceSection - Displays advisory-specific invoice information
 * Specific to Advisory order type
 * @param {Object} props - Component props
 * @param {Object} props.order - Order data
 */
const AdvisoryInvoiceSection = ({ order }) => {
  if (!order) return null;

  // Get tax calculation data from order
  const taxCalculation = order.latest_tax_calculation || {};

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="ENTRY INVOICE" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <FinancialRow
                label="Nationalization Taxes"
                valueBRL={taxCalculation.tributos_alfandegarios_brl}
                valueUSD={taxCalculation.tributos_alfandegarios_usd}
              />
              <FinancialRow
                label="Customs Expenses"
                valueBRL={taxCalculation.despesas_aduaneiras}
                valueUSD={taxCalculation.despesas_aduaneiras / (taxCalculation.exchange_rate_dollar_to_real || 1)}
              />
              <FinancialRow
                label="ICMS Entry Base"
                valueBRL={taxCalculation.bc_icms_entrada}
                valueUSD={taxCalculation.base_calculo_icms_usd}
              />
              <FinancialRow
                label="Entry ICMS"
                valueBRL={taxCalculation.icms_entrada_brl}
                valueUSD={taxCalculation.icms_entrada_usd}
              />
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Total NF-e</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.nota_fiscal_brl)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.nota_fiscal_usd, 'USD')}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default AdvisoryInvoiceSection;